import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import ZoneUsageCard from "../../shared/scheme_dashboard/ZoneUsageCard";

type Level0WRSWidgetProps = {
  level0Resource: any;
};

const Level0WRSWidget: React.FunctionComponent<Level0WRSWidgetProps> = ({
  level0Resource,
}) => {
  const { t } = useTranslation();
  const [noOfCustomers, setNoOfCustomers] = useState(0);

  useEffect(() => {
    const subsciberWallets = new Set();

    if (level0Resource) {
      level0Resource.extractionRights.forEach((entitlement: any) =>
        subsciberWallets.add(entitlement.assertedByWalletId)
      );

      setNoOfCustomers(subsciberWallets.size);
    }
  }, [level0Resource]);

  return (
    <ZoneUsageCard
      name={level0Resource?.name}
      subscriberCount={noOfCustomers}
      subscribersLabel={t("level1wrs.subscribers")}
      waterClasses={(level0Resource?.waterClasses ?? []).map(
        (waterClass: any) => {
          const balance =
            waterClass.extractionHistory?.walletAccount?.h2WBalance;

          return {
            id: waterClass.id,
            name: waterClass.name,
            usage: balance || 0,
            // Unclamped: Polestar draws a negative balance as a full bar.
            share: balance / waterClass.volume,
          };
        }
      )}
    />
  );
};

export default Level0WRSWidget;
